webpackJsonp([161183335584001],{

/***/ 261:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(23);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _gatsbyImage = __webpack_require__(41);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _StyledComponents = __webpack_require__(12);
	
	var _PostGrid = __webpack_require__(68);
	
	var _PostGrid2 = _interopRequireDefault(_PostGrid);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ArchivePage = function ArchivePage(_ref) {
	  var data = _ref.data;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _StyledComponents.PageIntro,
	      null,
	      _react2.default.createElement(
	        'h1',
	        null,
	        'Musings'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'My thoughts and observations.'
	      )
	    ),
	    _react2.default.createElement(_PostGrid2.default, { data: data.posts })
	  );
	};
	
	exports.default = ArchivePage;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-musings-js-f5e4a73d48ef49da23f7.js